import { useNavigate } from 'react-router';
import { AuthLayout } from '../../ui/AuthLayout/AuthLayout';
import { AuthStep } from '../../ui/AuthStep/AuthStep';
import { AuthTitle } from '../../ui/AuthTitle/AuthTitle';
import { Notification } from '@/components/Notification/Notification';
import { getResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { useFormik } from 'formik';
import { passwordValidationSchema } from './const/const';
import { useMutation } from '@tanstack/react-query';
import { forgotPasswordSetPassword } from './api';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { getForgotPasswordPasswordChangedPath } from '../path';
import { SetPasswordForm } from '@/bundle/shared/components/SetPasswordForm/SetPasswordForm';

type PasswordConfirmationFormType = {
  password: string;
  passwordConfirmation: string;
};

export const ForgotPasswordSetPasswordPage = () => {
  const navigate = useNavigate();

  const { mutate, data, isPending } = useMutation({
    mutationKey: ['set_password'],
    mutationFn: (password: string) => {
      const payload = {
        password,
      };

      return forgotPasswordSetPassword(payload);
    },
    onSuccess(response) {
      if (response?.error) return;

      amplitudeService.logEvent(AMPLITUDE_EVENTS.ForgotPasswordSetPasswordSuccess);

      navigate(getForgotPasswordPasswordChangedPath());
    },
  });

  const formik = useFormik<PasswordConfirmationFormType>({
    initialValues: {
      password: '',
      passwordConfirmation: '',
    },
    onSubmit: (values) => {
      mutate(values.password);
    },
    validationSchema: passwordValidationSchema,
  });

  const error = getResponseError(data?.error);

  return (
    <AuthLayout>
      <AuthStep>
        <AuthTitle>Set Your Password</AuthTitle>

        {error && (
          <Notification variant='error' marginBottom='24px'>
            {error}
          </Notification>
        )}

        <SetPasswordForm formik={formik} apiError={data?.error} isLoading={isPending} />
      </AuthStep>
    </AuthLayout>
  );
};
